/**
 * Statuses worth reporting: 400, 402 and 405-599.
 *
 * 401, 403 and 404 are excluded because they are expected outcomes rather than
 * bugs — a key without access, a spoofed origin, or a resource that genuinely
 * isn't there.
 */
export const FAILED_REQUEST_STATUS_CODES: (number | [number, number])[] = [
  400,
  402,
  [405, 599],
];

/**
 * Hosts that count as "our API".
 *
 * These are enumerated instead of using a blanket `*.locallogic.co` because
 * that would also match the subdomains serving the SDK bundle and static
 * assets, turning a CDN hiccup into a phantom API error. The `//` prefix
 * anchors each pattern to the host so the patterns can't bleed into paths.
 */
export const FAILED_REQUEST_TARGETS = [
  // v3 + neighborhood-management, leads reports, commute/directions.
  /\/\/(api|reports-api|providers-api)(-qa)?\.locallogic\.co/,
  // Analytics ingestion. Fire-and-forget, so a failure won't break a widget,
  // but a 5xx here means our tracking backend is down.
  /\/\/analytics\.locallogic\.co/,
];
